export enum Config {
  SPARNATURAL_CONFIG_CORE = "http://data.sparna.fr/ontologies/sparnatural-config-core#",
  LITERAL_LIST_PROPERTY = "http://data.sparna.fr/ontologies/sparnatural-config-core#" +
    "LiteralListProperty",

  AUTOCOMPLETE_PROPERTY = "http://data.sparna.fr/ontologies/sparnatural-config-core#" +
    "AutocompleteProperty",
  BOOLEAN_PROPERTY = "http://data.sparna.fr/ontologies/sparnatural-config-core#" +
    "BooleanProperty",
  GRAPHDB_SEARCH_PROPERTY = "http://data.sparna.fr/ontologies/sparnatural-config-core#" +
    "GraphDBSearchProperty",
  JENA_SEARCH_PROPERTY = "http://data.sparna.fr/ontologies/sparnatural-config-core#" +
    "JenaSearchProperty",
  LIST_PROPERTY = "http://data.sparna.fr/ontologies/sparnatural-config-core#" +
    "ListProperty",
  MAP_PROPERTY = "http://data.sparna.fr/ontologies/sparnatural-config-core#" +
    "MapProperty",
  NON_SELECTABLE_PROPERTY = "http://data.sparna.fr/ontologies/sparnatural-config-core#" +
    "NonSelectableProperty",
  NUMBER_PROPERTY = "http://data.sparna.fr/ontologies/sparnatural-config-core#" +
    "NumberProperty",
  SEARCH_PROPERTY = "http://data.sparna.fr/ontologies/sparnatural-config-core#" +
    "SearchProperty",
  STRING_EQUALS_PROPERTY = "http://data.sparna.fr/ontologies/sparnatural-config-core#" +
    "StringEqualsProperty",
  TIME_PROPERTY_DATE = "http://data.sparna.fr/ontologies/sparnatural-config-core#" +
    "TimeProperty-Date",
  TIME_PROPERTY_PERIOD = "http://data.sparna.fr/ontologies/sparnatural-config-core#" +
    "TimeProperty-Period",
  TIME_PROPERTY_YEAR = "http://data.sparna.fr/ontologies/sparnatural-config-core#" +
    "TimeProperty-Year",
  TREE_PROPERTY = "http://data.sparna.fr/ontologies/sparnatural-config-core#" +
    "TreeProperty",
  VIRTUOSO_SEARCH_PROPERTY = "http://data.sparna.fr/ontologies/sparnatural-config-core#" +
    "VirtuosoSearchProperty",

  SPARQL_STRING = "http://data.sparna.fr/ontologies/sparnatural-config-core#" +
    "sparqlString",
  ICON = "http://data.sparna.fr/ontologies/sparnatural-config-core#" + "icon",
  FA_ICON = "http://data.sparna.fr/ontologies/sparnatural-config-core#" +
    "faIcon",
  HIGHLIGHTED_ICON = "http://data.sparna.fr/ontologies/sparnatural-config-core#" +
    "highlightedIcon",
  ORDER = "http://data.sparna.fr/ontologies/sparnatural-config-core#" + "order",
  TOOLTIP = "http://data.sparna.fr/ontologies/sparnatural-config-core#" +
    "tooltip",
  ENABLE_OPTIONAL = "http://data.sparna.fr/ontologies/sparnatural-config-core#" +
    "enableOptional",
  ENABLE_NEGATION = "http://data.sparna.fr/ontologies/sparnatural-config-core#" +
    "enableNegation",
  IS_MULTILINGUAL = "http://data.sparna.fr/ontologies/sparnatural-config-core#" +
    "isMultilingual",

  SPARQL_SERVICE = "http://data.sparna.fr/ontologies/sparnatural-config-core#" +
    "sparqlService",
  // note how this is not in the same namespace
    SERVICE_CLASS = "http://www.w3.org/ns/sparql-service-description#Service",
  // note how this is not in the same namespace
  ENDPOINT = "http://www.w3.org/ns/sparql-service-description#endpoint",

  DEFAULT_LABEL_PROPERTY = "http://data.sparna.fr/ontologies/sparnatural-config-core#" +
    "defaultLabelProperty",
  EXACT_DATE_PROPERTY = "http://data.sparna.fr/ontologies/sparnatural-config-core#" +
    "exactDateProperty",
  BEGIN_DATE_PROPERTY = "http://data.sparna.fr/ontologies/sparnatural-config-core#" +
    "beginDateProperty",
  END_DATE_PROPERTY = "http://data.sparna.fr/ontologies/sparnatural-config-core#" +
    "endDateProperty",

  SPARNATURAL_CLASS = "http://data.sparna.fr/ontologies/sparnatural-config-core#" +
    "SparnaturalClass",
  NOT_INSTANTIATED_CLASS = "http://data.sparna.fr/ontologies/sparnatural-config-core#" +
    "NotInstantiatedClass",
  RDFS_LITERAL = "http://www.w3.org/2000/01/rdf-schema#Literal",
}
